.offer {
  margin-bottom: 1em;
  border-radius: var(--offer-border-radius);
  border: 1px solid var(--offer-border-color);
  overflow: hidden;
  background-color: var(--offer-body-bg-color);

  display: grid;
  grid-template-columns: subgrid;
  grid-column: 1/4;

  &:last-child {
    margin-bottom: 0;
  }

  &TermsOpen {
    :global {
      .offer__terms-cta__icon {
        transform: rotate(180deg);
      }
    }
  }
}
